import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the PaymentMethodSelectPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
 
@Component({
  selector: 'page-payment-method-select',
  templateUrl: 'payment-method-select.html',
})
export class PaymentMethodSelectPage {

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
  	public viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PaymentMethodSelectPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/payment-method-select/payment-method-select.ts